export const areachartWidgetData = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  datasets: [{
    label: 'Dataset 1',
    borderColor: '#f44336',
    data: [6, 4, 8, 6, 4, 3, 6, 8, 7, 3, 5, 4]
  }]
};
